/** Maximum number of enrolled hosts (including lighthouses and relays) allowed on the free plan */
export const FREE_PLAN_HOST_LIMIT = 100;

/** Whole dollars charged per enrolled host per month on the Pro plan */
export const PRO_PRICE_PER_HOST_USD = 1;

/** Pro plan feature bullets, shared by the upsell and checkout screens so the two stay in sync */
export const PRO_PLAN_FEATURES = [
  'Unlimited hosts',
  'Up to 100 routes for external hosts',
  'Guaranteed uptime',
  'Priority support',
];
